global.$ = global.jQuery = require('jquery');
require('jquery-validation');
require('jquery-form');
require('jquery-mosaic');


